"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const _ = __importStar(require("lodash"));
const theme_1 = require("theme");
const icons_1 = __importDefault(require("constants/icons"));
const Clients_1 = require("components/partial/Clients");
const services_1 = require("services");
const native_1 = require("@react-navigation/native");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const RoadmapTypeContactEntity_1 = require("types/api/entity/RoadmapTypeContactEntity");
const ModalRoadmapMap_1 = __importDefault(require("components/modal/ModalRoadmapMap"));
const react_dropzone_1 = __importDefault(require("react-dropzone"));
const modal_1 = require("components/modal");
const ModalSelectRoadmapClientNewBrand_1 = __importDefault(require("components/modal/ModalSelectRoadmapClientNewBrand"));
const PlanningRoadmapEditNewAdic = ({ route, navigation }) => {
    console.log("PlanningRoadmapEditNewAdic");
    const { client: clientParam, id, clearToken: clearTokenParam, } = route?.params ?? {};
    const toast = (0, native_base_1.useToast)();
    const inputDateRef = React.useRef();
    const existentClientChanged = React.useRef(false);
    const [client, setClient] = React.useState(clientParam);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        if (clientParam) {
            existentClientChanged.current = true;
            setClient(clientParam);
        }
    }, [clientParam?.id]));
    const [showUpdateDateBtn, setShowUpdateDateBtn] = React.useState(false);
    const [showUpdateClientBtn, setShowUpdateClientBtn] = React.useState(false);
    const [showModalDateChangeSuccess, setShowModalDateChangeSuccess] = React.useState(false);
    const [initResponse, setInitResponse] = React.useState();
    const [isLoading, setIsLoading] = React.useState(false);
    const [roadmapGetResponse, setRoadmapGetResponse] = React.useState();
    const [day, setDay] = React.useState();
    const [hour, setHour] = React.useState();
    const [minute, setMinute] = React.useState();
    const [clientNew, setClientNew] = React.useState(false);
    const [clientNewName, setClientNewName] = React.useState("");
    const [clientNewRuc, setClientNewRuc] = React.useState("");
    const [clientNewPhone, setClientNewPhone] = React.useState("");
    const [clientNewAddress, setClientNewAddress] = React.useState("");
    const [clientNewPot, setClientNewPot] = React.useState(false);
    const [showSelectClientNewBrand, setShowSelectClientNewBrand] = React.useState(false);
    const [brandsClientNewSelected, setBrandsClientNewSelected] = React.useState();
    const [address, setAddress] = React.useState();
    const latRef = React.useRef();
    const lngRef = React.useRef();
    const [category, setCategory] = React.useState();
    const [nameComercial, setNameComercial] = React.useState();
    const [personContact, setPersonContact] = React.useState();
    const [email, setEmail] = React.useState();
    const [addressFiscal, setAddressFiscal] = React.useState();
    const [addressDispatch, setAddressDispatch] = React.useState();
    const [zone, setZone] = React.useState();
    const [agenciero, setAgenciero] = React.useState();
    const [warehouseChecklist, setWarehouseChecklist] = React.useState();
    const [warehouseVisible, setWarehouseVisible] = React.useState(false);
    const [discountChecklist, setDiscountChecklist] = React.useState();
    const [discountVisible, setDiscountVisible] = React.useState(false);
    const [showModalMap, setShowModalMap] = React.useState(false);
    const onBackPres = () => {
        navigation.navigate("PlanningRoadmapName");
    };
    const onDayPressed = () => {
        if (roadmapGetResponse?.data?.enviado == true) {
            return;
        }
        console.log(inputDateRef.current);
        inputDateRef.current.showPicker();
    };
    const onClientSearchPressed = () => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        navigation.navigate(Clients_1.name, {
            origin: "PlanningRoadmapEditNewAdic",
            roadmapId: id,
        });
    };
    const onClientNewPressed = () => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        setClientNew(true);
    };
    const onClientNoNewPressed = () => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        setClientNew(false);
    };
    const onProspectingPressed = (prospecting) => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        setWarehouseChecklist(old => {
            let news = old?.map(e => {
                return {
                    code: e.code,
                    name: e.name,
                    check: e.check,
                };
            });
            news?.forEach(e => {
                if (e.code == prospecting.code) {
                    e.check = e.check == "1" ? "0" : "1";
                }
            });
            return news;
        });
    };
    const onCreateClientPressed = () => {
        console.log("nameComercial=", nameComercial);
        console.log("category=", category);
        const onSuccess = (response) => {
            navigation.navigate("PlanningRoadmapName");
            toast.show({ description: response.msg });
        };
        const onFail = (msg) => {
            toast.show({ description: msg });
        };
        (0, services_1.doRoadmapClientNewSave)({
            params: {
                data: {
                    files: files,
                    hojaId: id,
                    parentCardCode: client?.id,
                    contactoNombre: personContact, //"";
                    contactoCorreo: email, //"";
                    contactoDireccionFiscal: addressDispatch, //"";
                    contactoDireccionDespacho: addressDispatch, //"";
                    contactoZona: zone, //"";
                    geoLatitud: latRef.current?.toString(), //"";
                    geoLongitud: lngRef.current?.toString(), //"";
                    geoDireccion: address, //"";
                    agenciero: agenciero, //"";
                    categoria: category?.code, //"";
                    nombreComercial: nameComercial, //"";
                    almacenes: warehouseChecklist?.map(e => {
                        return {
                            code: e.code,
                            check: e.check,
                        };
                    }),
                    descuentos: discountChecklist?.map(e => {
                        return {
                            code: e.code,
                            primero: e.primero,
                            segundo: e.segundo,
                        };
                    }), //"";
                },
            },
            callback: {
                onSuccess,
                onFail,
                onLoading: setIsLoading,
            },
        });
    };
    const onDiscountText1Changed = (text, item) => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        if (isNaN(Number(text))) {
            setDiscountChecklist(old => old);
        }
        else {
            setDiscountChecklist(old => {
                let news = old?.map(brand => {
                    return {
                        code: brand.code,
                        name: brand.name,
                        primero: item.code == brand.code ? text : brand.primero,
                        segundo: brand.segundo,
                    };
                });
                return news;
            });
        }
    };
    const onDiscountText2Changed = (text, item) => {
        if (roadmapGetResponse?.data?.enviado == true)
            return;
        if (isNaN(Number(text))) {
            setDiscountChecklist(old => old);
        }
        else {
            setDiscountChecklist(old => {
                let news = old?.map(brand => {
                    return {
                        code: brand.code,
                        name: brand.name,
                        primero: brand.primero,
                        segundo: item.code == brand.code && (brand.primero ?? "") != "" ? text : brand.segundo,
                    };
                });
                return news;
            });
        }
    };
    const renderItemWarehouse = ({ item }) => {
        return <WarehouseItem item={item} onItemPressed={onProspectingPressed}/>;
    };
    const renderItemDiscount = ({ item }) => {
        return (<DiscountItem item={item} onChangeText1={onDiscountText1Changed} onChangeText2={onDiscountText2Changed}/>);
    };
    React.useEffect(() => {
        const onSuccess = async (response) => {
            setInitResponse(response);
            setWarehouseChecklist(response.data.almacenes);
            setDiscountChecklist(response.data.lineasDescuento);
            await new Promise(resolve => setTimeout(resolve, 10));
            doRoadmapGetRequest(response);
        };
        (0, services_1.doRoadmapInit)({
            params: {},
            callback: {
                onSuccess,
            },
        });
        return () => {
            console.log("useFocusEffect return");
        };
    }, [id, clearTokenParam]);
    const doRoadmapGetRequest = (initResponse) => {
        const onSuccess = (response) => {
            //response.data.enviado = true;
            setRoadmapGetResponse(response);
            setDay(response.data.dia);
            setHour(response.data.hora);
            setMinute(response.data.minuto);
            setClientNewName(response?.data?.clienteNuevoNombre ?? "");
            setClientNewRuc(response?.data?.clienteNuevoRuc ?? "");
            setClientNewPhone(response?.data?.clienteNuevoTelefono ?? "");
            setClientNewAddress(response?.data?.clienteNuevoDireccion ?? "");
            setClientNewPot(response?.data?.clienteNuevoPotencial == 1);
            if (initResponse) {
                const codes = response?.data?.clienteNuevoMarcas?.split(",") ?? [];
                setBrandsClientNewSelected(initResponse.data?.marcasClienteNuevo?.filter(e => codes.includes(e?.code?.toString() ?? "")));
            }
            if (response?.data?.enviado == true) {
                setNameComercial(response.data?.clienteNuevoNombreComercial);
                setPersonContact(response.data?.contactoNombre);
                setEmail(response.data?.contactoCorreo);
                setAddressFiscal(response.data?.contactoDireccionFiscal);
                setAddressDispatch(response.data?.contactoDireccionDespacho);
                setZone(response.data?.contactoZona);
                setAgenciero(response.data?.agenciero);
                console.log("initResponse", initResponse);
                console.log(initResponse?.data?.categoriaCliente?.find(e => e.code == response.data?.clienteNuevoCategoria));
                setCategory(initResponse?.data?.categoriaCliente?.find(e => e.code == response.data?.clienteNuevoCategoria));
                setAddress(response.data?.geoDireccion);
                setDiscountChecklist(response.data?.descuentos);
                setWarehouseChecklist(response.data?.almacenesDespacho);
                setFiles([]);
            }
            else {
                setClient(undefined);
                setNameComercial("");
                setPersonContact("");
                setEmail("");
                setAddressFiscal("");
                setAddressDispatch("");
                setZone("");
                setAgenciero("");
                setCategory(undefined);
                setAddress(undefined);
                setFiles([]);
                setWarehouseChecklist(initResponse.data.almacenes);
                setDiscountChecklist(initResponse.data.lineasDescuento);
            }
        };
        (0, services_1.doRoadmapGet)({
            params: {
                data: {
                    hojaId: id,
                },
            },
            callback: {
                onSuccess,
            },
        });
    };
    const onUpdateDatePressed = (onSuccess) => {
        doRoadmapDateUpdateRequest({
            fecha: day,
            hora: hour,
            minuto: minute,
            onSuccess: onSuccess,
        });
    };
    const onUpdateClientPressed = () => {
        onUpdateDatePressed(() => {
            toast.show({ description: "Programación cambiada" });
            const onSuccess = (response) => {
                setShowModalDateChangeSuccess(true);
            };
            (0, services_1.doRoadmapClientUpdate)({
                params: {
                    data: {
                        hojaId: id,
                        nombre: clientNewName,
                        ruc: clientNewRuc,
                        telefono: clientNewPhone,
                        direccion: clientNewAddress,
                        clienteNuevoPotencial: clientNewPot == true ? 1 : 0,
                    },
                },
                callback: {
                    onSuccess,
                },
            });
        });
    };
    const doRoadmapDateUpdateRequest = ({ fecha, hora, minuto, onSuccess, }) => {
        if (roadmapGetResponse?.data?.enviado == true) {
            return;
        }
        const onSuccessInternal = (response) => {
            //response.data.enviado = true;
            setRoadmapGetResponse(response);
            setDay(response.data.dia);
            setHour(response.data.hora);
            setMinute(response.data.minuto);
            if (onSuccess == undefined)
                setShowModalDateChangeSuccess(true);
            setShowUpdateDateBtn(false);
        };
        (0, services_1.doRoadmapDateUpdate)({
            params: {
                data: {
                    hojaId: id,
                    fecha: fecha ?? roadmapGetResponse?.data?.dia,
                    hora: hora ?? roadmapGetResponse?.data?.hora,
                    minuto: minuto ?? roadmapGetResponse?.data?.minuto,
                },
            },
            callback: {
                onSuccess: onSuccessInternal,
            },
        });
    };
    //file
    const [files, setFiles] = React.useState([]);
    const onDrop = React.useCallback((acceptedFiles) => {
        setFiles(acceptedFiles);
    }, []);
    //
    const dropzoneRef = React.createRef();
    /*useFocusEffect(
        React.useCallback(() => {
            doRoadmapGetRequest();
            return () => {};
        }, [id]),
    );*/
    console.log("PlanningRoadmapEditNewAdic return");
    return (<>
			<native_base_1.ScrollView style={{ width: "100%" }} _contentContainerStyle={{
            alignItems: "center",
            px: {
                base: 15,
                md: 15,
            },
        }}>
				<native_base_1.View w={{ base: "100%", md: "90%", lg: "75%", xl: "65%" }} pb="10">
					<native_base_1.VStack mt="30">
						<native_base_1.Text variant="body2">{roadmapGetResponse?.data.razonSocial ?? ""}</native_base_1.Text>

						<native_base_1.HStack alignItems="center">
							<native_base_1.Pressable onPress={onBackPres}>
								<native_base_1.Image width={15} height={15} marginRight="10" source={require("images/ic_back.svg")} alt={"dd"}/>
							</native_base_1.Pressable>
							<native_base_1.Text flex={1}>Cliente nuevo</native_base_1.Text>
							<native_base_1.HStack bg="white" borderRadius={10} borderWidth={1} borderColor={theme_1.Colors.colorLightGray1} px={10} py={5} alignItems="center">
								<native_base_1.Text mr={10}>
									{initResponse?.data?.tiposContacto?.find(e => e.code == roadmapGetResponse?.data?.contactoTipo)?.name ?? ""}
								</native_base_1.Text>
								<native_base_1.Image alt="_" source={roadmapGetResponse?.data?.contactoTipo == RoadmapTypeContactEntity_1.RoadmapTypeContact.call
            ? icons_1.default.icPhoneOutline
            : icons_1.default.imgHomeOutline} w={15} h={15}/>
							</native_base_1.HStack>
						</native_base_1.HStack>
						{/* dia - hora - minuto */}
						<native_base_1.HStack mt={20}>
							<input width={0} height={0} style={{
            position: "absolute",
            visibility: "hidden",
            height: 0,
            width: 0,
        }} ref={inputDateRef} type="date" onChange={e => {
            console.log("e.target.value", e.target.value);
            setDay(e.target.value);
            setShowUpdateDateBtn(true);
            //doRoadmapDateUpdateRequest({fecha: e.target.value});
        }}/>

							<native_base_1.Pressable onPress={onDayPressed} flex={1}>
								<native_base_1.Text bg="white" borderRadius={10} borderWidth={1} borderColor={theme_1.Colors.colorLightGray1} px={10} py={10}>
									{roadmapGetResponse?.data?.dia ?? ""}
								</native_base_1.Text>
							</native_base_1.Pressable>
							<native_base_1.View flex={1} bg="white" borderRadius={10} borderWidth={1} borderColor={theme_1.Colors.colorLightGray1} ml={15}>
								{roadmapGetResponse?.data.enviado == true ? (<native_base_1.Text py={10} px={10}>
										{hour}
									</native_base_1.Text>) : (<native_base_1.Select key={hour} bg="white" borderRadius={10} borderWidth={0} borderColor={theme_1.Colors.colorLightGray1} selectedValue={hour} accessibilityLabel="Choose Service" placeholder="Hora" _selectedItem={{
                bg: "teal.600",
                endIcon: <native_base_1.CheckIcon size="5"/>,
            }} onValueChange={itemValue => {
                setHour(itemValue);
                setShowUpdateDateBtn(true);
                /*doRoadmapDateUpdateRequest({
                    hora: itemValue,
                });*/
            }}>
										{_.range(0, 24).map((e, i) => (<native_base_1.Select.Item key={"asd" + i} label={e.toString().length == 1 ? `0${e.toString()}` : e.toString()} value={e.toString().length == 1 ? `0${e.toString()}` : e.toString()}/>))}
									</native_base_1.Select>)}
							</native_base_1.View>
							<native_base_1.View flex={1} bg="white" borderRadius={10} borderWidth={1} borderColor={theme_1.Colors.colorLightGray1} ml={15}>
								{roadmapGetResponse?.data.enviado == true ? (<native_base_1.Text py={10} px={10}>
										{minute}
									</native_base_1.Text>) : (<native_base_1.Select key={minute} borderWidth={0} selectedValue={minute} minWidth="40" accessibilityLabel="Choose minute" placeholder="Minuto" _selectedItem={{
                bg: "teal.600",
                endIcon: <native_base_1.CheckIcon size="5"/>,
            }} onValueChange={itemValue => {
                setMinute(itemValue);
                setShowUpdateDateBtn(true);
                /*doRoadmapDateUpdateRequest({
                    minuto: itemValue,
                });*/
            }}>
										{_.range(0, 60).map((e, i) => (<native_base_1.Select.Item background="colorLine" key={i} label={e.toString().length == 1 ? `0${e.toString()}` : e.toString()} value={e.toString().length == 1 ? `0${e.toString()}` : e.toString()}/>))}
									</native_base_1.Select>)}
							</native_base_1.View>
						</native_base_1.HStack>

						{showUpdateDateBtn && roadmapGetResponse?.data?.clienteNuevo != "1" && (<native_base_1.Button mt={10} onPress={() => {
                onUpdateDatePressed(undefined);
            }}>
								Actualizar
							</native_base_1.Button>)}

						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Nombre:{" "}
							</native_base_1.Text>
							<native_base_1.Input editable={roadmapGetResponse?.data?.enviado == false && showUpdateClientBtn} style={{
            minHeight: 40,
            minWidth: 100,
            flex: 1,
            borderWidth: showUpdateClientBtn ? 1 : 0,
            borderRadius: theme_1.Sizes.inputRadius,
            paddingHorizontal: showUpdateClientBtn ? 10 : 0,
            backgroundColor: showUpdateClientBtn ? "white" : "transparent",
        }} outline="none" focusable={showUpdateClientBtn} value={clientNewName} onChangeText={text => {
            setClientNewName(text);
            setShowUpdateClientBtn(true);
        }}/>
							{roadmapGetResponse?.data?.enviado == false && (<native_base_1.Pressable padding={10} onPress={() => {
                setShowUpdateClientBtn(true);
            }}>
									<native_base_1.Image w={15} h={15} source={icons_1.default.icEdit}/>
								</native_base_1.Pressable>)}
						</native_base_1.HStack>
						<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Ruc:{" "}
							</native_base_1.Text>

							<native_base_1.Input editable={roadmapGetResponse?.data?.enviado == false && showUpdateClientBtn} style={{
            minHeight: 40,
            minWidth: 100,
            flex: 1,
            borderWidth: showUpdateClientBtn ? 1 : 0,
            borderRadius: theme_1.Sizes.inputRadius,
            paddingHorizontal: showUpdateClientBtn ? 10 : 0,
            backgroundColor: showUpdateClientBtn ? "white" : "transparent",
        }} outline="none" value={clientNewRuc} onChangeText={text => {
            setClientNewRuc(text);
            setShowUpdateClientBtn(true);
        }}/>
						</native_base_1.HStack>
						<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Telefono:{" "}
							</native_base_1.Text>

							<native_base_1.Input editable={roadmapGetResponse?.data?.enviado == false && showUpdateClientBtn} style={{
            minHeight: 40,
            minWidth: 100,
            flex: 1,
            borderWidth: showUpdateClientBtn ? 1 : 0,
            borderRadius: theme_1.Sizes.inputRadius,
            paddingHorizontal: showUpdateClientBtn ? 10 : 0,
            backgroundColor: showUpdateClientBtn ? "white" : "transparent",
        }} outline="none" value={clientNewPhone} onChangeText={text => {
            setClientNewPhone(text);
            setShowUpdateClientBtn(true);
        }}/>
						</native_base_1.HStack>
						<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Dirección:{" "}
							</native_base_1.Text>

							<native_base_1.Input editable={roadmapGetResponse?.data?.enviado == false && showUpdateClientBtn} style={{
            minHeight: 40,
            minWidth: 100,
            flex: 1,
            borderWidth: showUpdateClientBtn ? 1 : 0,
            borderRadius: theme_1.Sizes.inputRadius,
            paddingHorizontal: showUpdateClientBtn ? 10 : 0,
            backgroundColor: showUpdateClientBtn ? "white" : "transparent",
        }} outline="none" value={clientNewAddress} onChangeText={text => {
            setClientNewAddress(text);
            setShowUpdateClientBtn(true);
        }}/>
						</native_base_1.HStack>

						<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95} flex={1}>
								Potencial cliente:{" "}
							</native_base_1.Text>

							<native_base_1.HStack borderWidth={1} borderColor={theme_1.Colors.colorGray1} borderRadius={10}>
								<native_base_1.Pressable onPress={() => {
            if (!showUpdateClientBtn) {
                return;
            }
            setClientNewPot(true);
            setShowUpdateClientBtn(true);
        }}>
									<native_base_1.Text variant="body5" px={7} bg={clientNewPot ? theme_1.Colors.colorVividYellow1 : "white"} borderTopLeftRadius={10} borderBottomLeftRadius={10}>
										Si
									</native_base_1.Text>
								</native_base_1.Pressable>
								<native_base_1.Pressable onPress={() => {
            if (!showUpdateClientBtn) {
                return;
            }
            setClientNewPot(false);
            setShowUpdateClientBtn(true);
        }}>
									<native_base_1.Text variant="body5" px={7} bg={!clientNewPot ? theme_1.Colors.colorVividYellow1 : "white"} borderTopRightRadius={10} borderBottomRightRadius={10}>
										No
									</native_base_1.Text>
								</native_base_1.Pressable>
							</native_base_1.HStack>
						</native_base_1.HStack>

						<native_base_1.HStack mt={10} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Marca:{" "}
							</native_base_1.Text>
							<native_base_1.Pressable onPress={() => {
            //setShowSelectClientNewBrand(true);
        }} style={[{ flex: 1 }]} borderRadius={theme_1.Sizes.inputRadius} borderWidth={theme_1.Sizes.inputBorderWidth} minH={40} py={0}>
								<native_base_1.HStack alignItems="center" minH={40} px={10}>
									<native_base_1.Text flex={1}>{brandsClientNewSelected?.map(e => e.name ?? "")?.join(", ")}</native_base_1.Text>
									<native_base_1.Image w={10} h={10} source={icons_1.default.icMore}/>
								</native_base_1.HStack>
							</native_base_1.Pressable>
							<ModalSelectRoadmapClientNewBrand_1.default isOpen={showSelectClientNewBrand} onClose={() => {
            setShowSelectClientNewBrand(false);
        }} items={initResponse?.data?.marcasClienteNuevo} onAcceptPressed={items => {
            setBrandsClientNewSelected(items);
            setShowSelectClientNewBrand(false);
        }}/>
						</native_base_1.HStack>

						{(showUpdateClientBtn ||
            (showUpdateDateBtn && roadmapGetResponse?.data?.clienteNuevo == "1")) && (<native_base_1.Button mt={10} onPress={onUpdateClientPressed}>
								Actualizar
							</native_base_1.Button>)}
						{/* name comercial*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Nombre comercial:{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} value={nameComercial} onChangeText={setNameComercial} editable={roadmapGetResponse?.data?.enviado == false}/>
						</native_base_1.HStack>
						{/* category*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							{roadmapGetResponse?.data?.enviado == true ? (<native_base_1.HStack alignItems="center" px="0" py="5">
									<native_base_1.Text flex={1}>{category?.name ?? "Categoria"}</native_base_1.Text>
									<native_base_1.View w={10}/>
									<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
								</native_base_1.HStack>) : (<native_base_1.Menu trigger={triggerProps => {
                return (<native_base_1.Pressable borderRadius={10} accessibilityLabel="More options menu" {...triggerProps}>
												<native_base_1.HStack alignItems="center" px="0" py="5">
													<native_base_1.Text flex={1}>{category?.name ?? "Categoria"}</native_base_1.Text>
													<native_base_1.View w={10}/>
													<native_base_1.Image source={icons_1.default.icChevronDownFilled} w={10} h={10}/>
												</native_base_1.HStack>
											</native_base_1.Pressable>);
            }}>
									{initResponse?.data?.categoriaCliente?.map(e => {
                return (<native_base_1.Menu.Item onPress={() => {
                        if (roadmapGetResponse?.data?.enviado == true) {
                            return;
                        }
                        setCategory(e);
                    }}>
												<native_base_1.HStack alignItems="center" px={10}>
													<native_base_1.Text>{e.name ?? ""}</native_base_1.Text>
												</native_base_1.HStack>
											</native_base_1.Menu.Item>);
            })}
								</native_base_1.Menu>)}
						</native_base_1.HStack>
						{/* client child*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={10}>Cliente hijo</native_base_1.Text>
							<native_base_1.HStack borderWidth={1} borderColor={theme_1.Colors.colorGray1} borderRadius={10}>
								<native_base_1.Pressable onPress={onClientNewPressed}>
									<native_base_1.Text variant="body5" px={7} bg={clientNew ? theme_1.Colors.colorVividYellow1 : "white"} borderTopLeftRadius={10} borderBottomLeftRadius={10}>
										Si
									</native_base_1.Text>
								</native_base_1.Pressable>
								<native_base_1.Pressable onPress={onClientNoNewPressed}>
									<native_base_1.Text variant="body5" px={7} bg={!clientNew ? theme_1.Colors.colorVividYellow1 : "white"} borderTopRightRadius={10} borderBottomRightRadius={10}>
										No
									</native_base_1.Text>
								</native_base_1.Pressable>
							</native_base_1.HStack>
							<native_base_1.View flex={1}/>
							{clientNew && (<native_base_1.Pressable flex={1.7} onPress={onClientSearchPressed}>
									<native_base_1.HStack alignItems="center" bg="white" borderRadius={10} px={15} py={10}>
										<native_base_1.Text flex={1} mr={10}>
											{client?.nombre ?? "Buscar"}
										</native_base_1.Text>
										<native_base_1.Image source={icons_1.default.icSearch} w={15} h={15}/>
									</native_base_1.HStack>
								</native_base_1.Pressable>)}
						</native_base_1.HStack>
						{/* person*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Persona de Contacto:{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={roadmapGetResponse?.data?.enviado == false} value={personContact} onChangeText={setPersonContact}/>
						</native_base_1.HStack>
						{/* email*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Correo:{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={roadmapGetResponse?.data?.enviado == false} value={email} onChangeText={setEmail}/>
						</native_base_1.HStack>
						{/* fiscal*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Dirección fiscal:{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={roadmapGetResponse?.data?.enviado == false} value={addressFiscal} onChangeText={setAddressFiscal}/>
						</native_base_1.HStack>
						{/* Dispatch*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Dirección de despacho:{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={roadmapGetResponse?.data?.enviado == false} value={addressDispatch} onChangeText={setAddressDispatch}/>
						</native_base_1.HStack>
						{/* zone*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Zona:{" "}
							</native_base_1.Text>

							{roadmapGetResponse?.data?.enviado == true ? (<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={false} value={initResponse?.data?.zonas?.find(e => e.code == zone)?.name ?? ""}/>) : (initResponse?.data?.zonas && (<native_base_1.Select flex={1} key={zone ?? ""} borderWidth={1} borderColor="black" selectedValue={zone ?? ""} minWidth="40" accessibilityLabel="Choose Service" placeholder="" _selectedItem={{
                //bg: "teal.600",
                endIcon: <native_base_1.CheckIcon size="5"/>,
            }} mt={1} onValueChange={itemValue => {
                if (roadmapGetResponse?.data?.enviado == true)
                    return;
                setZone(itemValue);
            }}>
										{initResponse?.data?.zonas?.map((e, i) => (<native_base_1.Select.Item key={"asd" + i} label={e.name ?? ""} value={e.code ?? ""}/>))}
									</native_base_1.Select>))}
						</native_base_1.HStack>
						{/* adress*/}
						<native_base_1.HStack mt="20">
							<native_base_1.Pressable mr={15} onPress={() => {
            if (roadmapGetResponse?.data?.enviado == true)
                return;
            setShowModalMap(true);
        }}>
								<native_base_1.HStack px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
									<native_base_1.Text flex={1}>{address ?? "Ubicacion"}</native_base_1.Text>
									<native_base_1.Image source={icons_1.default.icMarker} w={15} h={15}/>
								</native_base_1.HStack>
							</native_base_1.Pressable>
							<native_base_1.VStack flex={1}>
								<native_base_1.Pressable onPress={() => {
            if (roadmapGetResponse?.data?.enviado == true)
                return;
            dropzoneRef.current?.open();
        }}>
									<native_base_1.HStack px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
										<native_base_1.Image source={icons_1.default.icPlus} w={10} h={10} mr={10}/>
										<native_base_1.Text>{files?.[0]?.name ?? "Cargar foto del local"}</native_base_1.Text>
									</native_base_1.HStack>
								</native_base_1.Pressable>
								<react_dropzone_1.default ref={dropzoneRef} onDrop={onDrop} onError={err => {
            console.log(err);
        }} maxFiles={1} multiple={false} accept={{
            "image/png": [".png", ".jpg", ".jpeg"],
            //"application/pdf": [".pdf"],
        }}>
									{({ getRootProps, getInputProps, isDragActive }) => (<div {...getRootProps()} style={{ width: "100%" }}>
											<input {...getInputProps()}/>
											{isDragActive ? (<p style={{
                    marginLeft: 20,
                    flex: 1,
                    width: "100%",
                }}></p>) : (<p style={{
                    marginLeft: 20,
                    flex: 1,
                    width: "100%",
                }}></p>)}
										</div>)}
								</react_dropzone_1.default>
							</native_base_1.VStack>
						</native_base_1.HStack>

						{/* warehouses*/}
						<native_base_1.VStack mt={20} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} bg="white">
							<native_base_1.Pressable onPress={() => {
            setWarehouseVisible(old => !old);
        }}>
								<native_base_1.HStack px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
									<native_base_1.Text flex={1}>Almacenes de despacho</native_base_1.Text>
									<native_base_1.Image source={icons_1.default.icMore} w={15} h={15}/>
								</native_base_1.HStack>
							</native_base_1.Pressable>

							{warehouseVisible && (<native_base_1.FlatList renderItem={renderItemWarehouse} data={warehouseChecklist}/>)}
						</native_base_1.VStack>

						{/* agenciero*/}
						<native_base_1.HStack mt={20} alignItems="center" py={5} borderColor={theme_1.Colors.colorGray1} borderBottomWidth={1}>
							<native_base_1.Text mr={20} minW={95}>
								Agenciero:*{" "}
							</native_base_1.Text>
							<react_native_1.TextInput style={[styles.input, { flex: 1 }]} editable={roadmapGetResponse?.data?.enviado == false} value={agenciero} onChangeText={setAgenciero}/>
						</native_base_1.HStack>

						{/* Descuentos*/}
						<native_base_1.VStack mt={20} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} bg="white">
							<native_base_1.Pressable onPress={() => {
            setDiscountVisible(old => !old);
        }}>
								<native_base_1.HStack px={15} py={5} borderWidth={1} borderRadius={10} borderColor={theme_1.Colors.colorLightGray1} alignItems="center">
									<native_base_1.Text flex={1}>Descuentos</native_base_1.Text>
									<native_base_1.Image source={icons_1.default.icMore} w={15} h={15}/>
								</native_base_1.HStack>
							</native_base_1.Pressable>

							{discountVisible && <native_base_1.FlatList renderItem={renderItemDiscount} data={discountChecklist}/>}
						</native_base_1.VStack>

						{/* boton*/}
						<native_base_1.HStack mt={20} px={20}>
							<native_base_1.Button isDisabled={roadmapGetResponse?.data?.enviado == true} flex={1} mr={15} onPress={onCreateClientPressed}>
								Crear cliente
							</native_base_1.Button>
						</native_base_1.HStack>
					</native_base_1.VStack>
				</native_base_1.View>
			</native_base_1.ScrollView>
			<ModalRoadmapMap_1.default isOpen={showModalMap} onClose={() => {
            setShowModalMap(false);
        }} onAccept={(address, lat, lng) => {
            setAddress(address);
            latRef.current = lat;
            lngRef.current = lng;
            setShowModalMap(false);
        }}/>
			<FullScreenLoad_1.default isVisible={isLoading}/>
			<modal_1.ModalMessage message={roadmapGetResponse?.data?.clienteNuevo == "1"
            ? "Datos del cliente actualizado"
            : "Programación cambiada"} isOpen={showModalDateChangeSuccess} onClose={() => {
            setShowModalDateChangeSuccess(false);
            navigation.navigate("PlanningRoadmapName");
        }}/>
		</>);
};
const WarehouseItem = ({ item, onItemPressed }) => {
    const onPressed = () => {
        onItemPressed(item);
    };
    return (<native_base_1.Pressable onPress={onPressed}>
			<native_base_1.HStack mt={10} borderBottomWidth={1} borderBottomColor={theme_1.Colors.colorLightGray1} px={15}>
				<native_base_1.Text flex={1} py={5}>
					{item.name ?? ""}
				</native_base_1.Text>
				<native_base_1.View w={20} h={20} alignItems="center" justifyContent="center" borderColor={theme_1.Colors.colorDarkGray1} borderWidth={1} borderRadius={5}>
					{item.check == "1" && <native_base_1.Image source={icons_1.default.icCheck} w={12} h={12}/>}
				</native_base_1.View>
			</native_base_1.HStack>
		</native_base_1.Pressable>);
};
const DiscountItem = ({ item, onChangeText1, onChangeText2 }) => {
    const onChangeTextInternal1 = (text) => {
        onChangeText1(text, item);
    };
    const onChangeTextInternal2 = (text) => {
        onChangeText2(text, item);
    };
    return (<native_base_1.HStack mt={4} borderBottomWidth={1} borderBottomColor={theme_1.Colors.colorLightGray1} px={15} alignItems="center" py="9">
			<native_base_1.Text flex={1} py={5}>
				{item.name ?? ""}
			</native_base_1.Text>
			<react_native_1.TextInput style={[
            styles.input,
            {
                width: 70,
                marginLeft: 10,
            },
        ]} value={item.primero ?? ""} onChangeText={onChangeTextInternal1}/>
			<react_native_1.TextInput style={[
            styles.input,
            {
                width: 70,
                marginLeft: 10,
            },
        ]} value={item.segundo ?? ""} onChangeText={onChangeTextInternal2}/>
		</native_base_1.HStack>);
};
const styles = react_native_1.StyleSheet.create({
    input: {
        padding: theme_1.Sizes.inputPaddingHorizontal,
        height: theme_1.Sizes.inputMinHeight - 10,
        borderRadius: theme_1.Sizes.inputRadius,
        borderWidth: theme_1.Sizes.inputBorderWidth,
        backgroundColor: "#ffffff",
    },
});
exports.name = "PlanningRoadmapEditNewAdicName";
exports.default = PlanningRoadmapEditNewAdic;
